import DataPackageAdapter from '../models/DataPackageAdapter'
import apiWrapper from './ApiWrapper'

export function getUserAllFriendship() {
    return new Promise((resolve, reject) => {
        apiWrapper.post('/api/Sharing/GetUserAllFriendshipWithSettings').then((response) => {
        //apiWrapper.post('/api/Sharing/GetUserAllFriendship').then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export function getUserFriendDataPackage({ friendUserId }) {
    return new Promise((resolve, reject) => {
        apiWrapper.post('/api/Sharing/GetUserFriendDataPackage', { friendUserId }).then((response) => {
            const dataPackage = DataPackageAdapter.adapt({ owner: 'friend', ...response });
            resolve(dataPackage)
        }).catch(error => {
            reject(error)
        })
    })
}

export function findUserByEmail({ friendEmail }) {
    return new Promise((resolve, reject) => {
        apiWrapper.post('/api/Sharing/FindUserByEmail', { searchedEmail: friendEmail }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export function sendFriendshipRequest({ TargetedUserId }) {
    return new Promise((resolve, reject) => {
        apiWrapper.post('/api/Sharing/SendFriendshipRequest', { TargetedUserId }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export function approuveFriendshipRequest({ requesterUserId }) {
    return new Promise((resolve, reject) => {
        apiWrapper.post('/api/Sharing/ApprouveFriendshipRequest', { requesterUserId }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export function removeFriend({ friendUserId }) {
    return new Promise((resolve, reject) => {
        apiWrapper.post('/api/Sharing/RemoveFriend', { friendUserId }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export function updateFriendshipSharingOptions({ friendUserId, portfolioSharingDetails }) {
    return new Promise((resolve, reject) => {
        apiWrapper.post('/api/Sharing/UpdateFriendshipSharingOptions', { friendUserId, portfolioSharingDetails }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}